<button #anchor (click)="toggle()" class="btn btn-light" [style.display]="mergedPopupConfig() ? 'inline' : 'none'">
	@if(mergedPopupConfig(); as popupConfig){
	<icon-text [iconContext]="popupConfig.iconContext"></icon-text>
	}
</button>
<div class="droplist-widget">

	@if(mergedPopupConfig();as popupConfig){
	@if(show){
	<kendo-popup #popup [anchor]="anchor" class="droplist-button-menu-content"
		[animate]="{ type: 'slide', direction: 'down', duration: 200 }">

		<h3 style='margin:0 0 0.5em 0.25em'>{{popupConfig.message}}</h3>
		@if(popupConfig){
		<ng-container *ngTemplateOutlet="dropdownTemplate"></ng-container>
		}

	</kendo-popup>
	}
	}
	@else {
	<ng-container *ngTemplateOutlet="dropdownTemplate"></ng-container>
	}

	<ng-template #dropdownTemplate>
		<kendo-dropdownlist [value]='selectedItem()' [data]="setup().data()" [valueField]="'uniqueId'" [textField]="'text'"
			[virtual]="true" [filterable]="isFilterable()" [itemDisabled]="itemDisabled" [defaultItem]="optionalText() ? defaultItem : null"
			[disabled]='readonly()' (filterChange)="handleFilter($event)" (valueChange)='valueChangeEvent($event)'
			[ngClass]='{"navigation-droplist": navigation(), "btn": navigation()}' style='width:100%;'
			(close)="onClose($event)">

			<ng-template kendoDropDownListNoDataTemplate>
				<i>{{missingDataMessage()}}</i>
			</ng-template>

			<ng-template kendoDropDownListValueTemplate let-dataItem>
				@if(dataItem){
				@if(createListValueTemplate(dataItem); as iconContext){
				<icon-text [iconContext]="iconContext"></icon-text>
				}
				}
			</ng-template>

			<ng-template kendoDropDownListItemTemplate let-dataItem>
				@if(createIconContext(dataItem); as iconContext){
				<icon-text [iconContext]="iconContext"></icon-text>
				}
			</ng-template>

		</kendo-dropdownlist>
	</ng-template>
</div>